import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import FeedbackDetailPage from "./pages/admin/FeedbackDetailPage";
import AdminLayout from "./pages/admin/AdminLayout";
import FeedbackPage from "./pages/admin/FeedbackPage";
import BuildingSetting from "./pages/admin/BuildingSetting/BuildingSetting";
import ListAllBuilding from "./pages/admin/ListAllBuilding";
import AddBuilding from "./pages/admin/AddBuilding/AddBuilding";
import TopRoutesPage from "./pages/admin/TopRoutesPage";
import SetQR from "./pages/admin/SetQR/SetQR";
import LoadingPage from "./pages/admin/Loading";
import AddDestination from "./pages/admin/AddDestination/AddDestination";
import AdditionalLocation from "./pages/admin/AdditionalLocation/AdditionalLocationEdit";
import Navigation from "./pages/admin/Navigation/Navigation";
import MapDrawing from "./pages/admin/MapDrawing";
import QrList from "./pages/admin/QrManagement/QrList";
import QrDetail from "./pages/admin/QrManagement/QrDetail";
import UserLayout from "./pages/User/UserLayout";
import MobileMainPage from "./pages/User/MobileMainPage";
import MobileMenuList from "./pages/User/MobileMenuList";
import UserNavigation from "./pages/User/UserNavigation";
import UserFeedback from "./pages/User/feedback";
import ScanRedirect from "./pages/User/ScanRedirect";

function AdminPage() {
  return (
    <Routes>
      {/* หน้า Login */}
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/admin"
        element={
          <ProtectedRoute allowRoles={["admin", "super_admin"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="feedback" element={<FeedbackPage />} />
        <Route path="feedback/:id" element={<FeedbackDetailPage />} />
        <Route path="top-routes" element={<TopRoutesPage />} />
        <Route path="buildings" element={<BuildingSetting />} />
        <Route path="buildings/add" element={<AddBuilding />} />
        <Route path="listallbuilding" element={<ListAllBuilding />} />
        <Route path="qr" element={<QrList />} />
        <Route path="qr/:id" element={<QrDetail />} />
      </Route>

      <Route
        path="admin2"
        element={
          <ProtectedRoute allowRoles={["admin", "super_admin"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<MapDrawing />} />
        <Route path="setqr" element={<SetQR />} />
        <Route path="adddestination" element={<AddDestination />} />
        <Route path="additionallocation" element={<AdditionalLocation />} />
        <Route path="navigation" element={<Navigation />} />
      </Route>

      <Route path="loading" element={<LoadingPage />} />

      {/* QR scan resolver (public) — เปิดจากมือถือหลังสแกน */}
      <Route path="scan/:code" element={<ScanRedirect />} />

      {/* user ไม่ต้อง login: default ไปหน้า user main */}
      <Route path="/" element={<Navigate to="/user/mainpage" replace />} />
      <Route path="*" element={<Navigate to="/user/mainpage" replace />} />

      <Route path="user" element={<UserLayout />}>
        <Route path="mainpage" element={<MobileMainPage />} />
        <Route path="usernavigation" element={<UserNavigation/>} />
        <Route path="cancle" element={<div>ยกเลิกแผนที่</div>} />
        <Route path="startend" element={<div>ข้อมูลจุดเริ่มต้นปลายทาง</div>} />
      </Route>

      <Route path="user2" element={<UserLayout />}>
        <Route path="menulist" element={<MobileMenuList />} />
        <Route path="detail" element={<div>ข้อมูลปลายทาง</div>} />
      </Route>

      <Route path="feedback" element={<UserFeedback/>} />
      <Route path="feedback2" element={<div>feedback2</div>} />
    </Routes>
  );
}

export default AdminPage;
